import { schema } from 'normalizr'
import { idAttribute, processStrategy } from 'modules/table'

const takeoutProductOption = new schema.Entity(
  'takeoutProductOptions',
  {},
  {
    idAttribute,
    processStrategy,
  }
)

export default takeoutProductOption
